import * as React from "react";
import { JoinFormUi, JoinFormUi_PresentationOf_Tnc } from "../../Common";
import {
  ContentRoutes,
  useContentRoute,
  useReactJoinInitialState,
} from "../providers";

export const PageJoin: React.FunctionComponent = () => {
  const { onUserWantsToSelectContentRoute } = useContentRoute();

  const handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered =
    React.useCallback(() => {
      onUserWantsToSelectContentRoute(ContentRoutes.Login);
    }, [onUserWantsToSelectContentRoute]);

  return (
    <section className="page page-join">
      <JoinFormUi
        useInitialState={useReactJoinInitialState}
        handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered={
          handleUserWantsToLoginInsteadBecauseTheirEmailIsAlreadyRegistered
        }
        presentationOfTnc={JoinFormUi_PresentationOf_Tnc.LongForm}
      />
    </section>
  );
};
